import { inject } from 'vue';
import type { InjectionKey } from 'vue';

import { assertValue } from './types';

export function injectStrict<T>(key: InjectionKey<T>): T {
  const resolved = inject(key);

  assertValue(resolved, `injectStrict > ${key.description}`);

  return resolved;
}
